module.exports = __webpack_public_path__ + "static/img/pure_project_cellar_c_logo.1a7e363.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pure_project_cellar_c_logo.png
// module id = 302
// module chunks = 1